import { render, staticRenderFns } from "./OrganizRegister.vue?vue&type=template&id=67654195&scoped=true&"
import script from "./OrganizRegister.vue?vue&type=script&lang=js&"
export * from "./OrganizRegister.vue?vue&type=script&lang=js&"
import style0 from "./OrganizRegister.vue?vue&type=style&index=0&id=67654195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67654195",
  null
  
)

export default component.exports